export const CLICK_LOCATIONS_PROVIDER_TILE =
  'user_action.provider_tile_locations_page';
export const CLICK_LOCATIONS_PROVIDER_TILE_BOOK_APPT =
  'user_action.book_appt_click_locations_page';
